import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const PageSkeleton = ({ rows = 4 }) => (
  <Box>
    <Skeleton variant="text" width={240} height={40} sx={{ mb: 1 }} />
    <Skeleton variant="text" width={360} height={24} sx={{ mb: 3 }} />
    <Stack spacing={1.5}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} variant="rounded" height={72} />
      ))}
    </Stack>
  </Box>
);

export default PageSkeleton;
